import React from "react";
import Navbar from "../../Navbar/Navbar";
import MobileNavbar from "../../MobileNavbar/MobileNavbar";
import styles from "./hero.module.scss";
import img from '../../../assets/Careers.jpg';
// import { Link } from "react-router-dom";
// import { FaAngleRight } from "react-icons/fa";

const Hero = () => {
  return (
    <section className={styles.hero_mainContainer} style={{backgroundImage: `url(${img})`}}>
      <Navbar />
      <MobileNavbar />

      <div className={styles.hero_container}>
        <div className={styles.hero_content_container}>
          <div>
            {/* <h1 className={styles.hero_heading}>join us</h1> */}
            <h1 className={styles.hero_heading}>MILLENSYS always searches for talented individuals</h1>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
